
export class Scorecard {
  constructor({
    animate,
    preview,
    update,
    animateOff,
    getVizPage,
    updateVizPage,
    vizSharedMemory,
  }) {
    this.onAir = false;
    this.sendAnimate = animate;
    this.sendAnimateOff = animateOff;
    this.sendPreview = preview;
    this.sendUpdate = update;
    this.getVizPage = getVizPage;
    this.updateVizPage = updateVizPage;
    this.vizSharedMemory = vizSharedMemory;
    this.name = "scorecard";
    this.scene = "scorecard";
    this.data = [];
    this.page = 108;
  }

  async preview({ options }) {
    this.onAir = false;

    await this.updateData({ options, show: 1 });
    // await this.updateData({ options, show: 2 });
    // await this.updateData({ options, show: 3 });
    // await this.updateData({ options, show: 4 });
    await this.sendPreview("page:read " + this.page);
  }
  async animate({ options }) {
    this.onAir = true;
    this.sendAnimate({ page: this.page });
  }
  animateOff({ options }) {
    this.onAir = false;
    this.sendAnimateOff({ page: this.page });
  }

  async updateData({ options, show }) {
    let xml = await this.getVizPage({ page: this.page, show }).catch((err) => {
      console.log(err);
    });
    if (xml) {

      xml.payload.field.find((item) => {
        return item.attr.name === "0001";
      }).value = (options?.period.number || "");

       xml.payload.field.find((item) => {
        return item.attr.name === "300";
      }).value = (options?.game?.home_fighter?.last_name.toUpperCase()  || "");

       xml.payload.field.find((item) => {
        return item.attr.name === "400";
      }).value = (options?.game?.away_fighter?.last_name.toUpperCase()  || "");

      const scorecard = options.scorecard;

      scorecard.forEach((score, i) => {
        const indexPrefix = (i + 3).toString();
        const round = score.rounds
        round.forEach((roundscore, x) => {
          const roundNumber = x + 1;      
          const scoreFieldId = roundNumber < 10 ? `${indexPrefix}0${roundNumber}`
          : `${indexPrefix}${roundNumber}`
          const scoreField = xml.payload.field.find(item => item.attr.name === scoreFieldId);
          if (scoreField) {
          scoreField.value = roundscore?.score
          }
        }) 
      })


      await this.updateVizPage({
        page: this.page,
        data: xml,
        escape: false,
        show,
      }).catch((err) => {
        console.log(err);
      });
    }
  }

  update({ options }) {}
}
